import { decodeOneOf, encodeOneOf } from '../../../../../domain';
import { CompanyUsersKeys } from '../company-users.key';
import { Places } from '../../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'uf';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /**
     * Qual PAPEL o formulario de usuario esta cadastrando - administrador ou
     * profissional.
     *
     * Sao o mesmo formulario mais dois campos, e por isso um place so: dois places
     * dariam duas classes iguais cuja unica diferenca seria o nome. Mesma decisao do
     * `companyEdit`, que cadastra e edita no mesmo lugar.
     */
    CompanyUserRole: `${PREFIX}a`
};
export const COMPANY_ROLE_CODES = {
    '0': 'admin',
    '1': 'profissional'
};
/**
 * O dialogo que cadastra um usuario para a empresa.
 *
 * Um place so para os dois papeis: sao o mesmo formulario mais dois campos, e dois
 * places dariam duas classes iguais cuja unica diferenca seria o nome - a mesma
 * decisao do `companyEdit`, que cadastra e edita no mesmo lugar.
 *
 * Herda de `CompanyUsersKeys`, entao a aba e a empresa escolhida viajam para o
 * dialogo e voltam com ele.
 */
export class CompanyUserFormKeys extends CompanyUsersKeys {
    get place() {
        return Places.companyUserForm;
    }
    get role() {
        return decodeOneOf(this._intent.getParameterAsString(P.CompanyUserRole), COMPANY_ROLE_CODES, 'admin');
    }
    set role(value) {
        this._intent.setParameter(P.CompanyUserRole, value === 'admin' ? undefined : encodeOneOf(value, COMPANY_ROLE_CODES));
    }
}
//# sourceMappingURL=company-user-form.key.js.map